import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getProformaEntitiesAction } from "../../../../actions/proformaAction";
import { AgGridReact } from "ag-grid-react";
import { SBAComboBox, SBAAutoComplete } from "../../../../UiComponents/SBADropDown";
import { getEntities } from "../../../../../config/apiConfig";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { getUniverseMembersAction } from "../../../../actions/universeMembers";

export const AssetandGroup = ({ setShowDrawer, handleAddSelectedRows }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const gridApiRef = useRef(null);

  const [selectedOption, setSelectedRadioOption] = useState("asset");
  const [selectedEntity, setselectedEntity] = useState();
  const [isContains, setContains] = useState(false);
  const [universeList, setUniverseList] = useState([]);
  const [filteredAsset, setFilteredAsset] = useState([]);
  const [filteredGroup, setFilteredGroup] = useState([]);
  const [showGridValue,setShowGridValue]=useState(false);

  const Gstate = useSelector((state) => state) || {};
  const ProformaEntities = Gstate.ProformaConstruction?.ProformaEntitiesData || [];
  const universeItem = Gstate.AnalyticsReporting.memberList.UniverseMemberDetails || [];
  const formattedUniverseItem=universeItem.map(item=>{
    return {
      "EntityId": item.MemberEntityId,
      "EntityName": item.MemberName,
      "ShortName":item.MemberName,
      "EntityTypeId": item.MemberEntityTypeId,
      "EntityTypeName": item.MemberEntityTypeName,
      "StrategyId": item.StrategyId,
      "StrategyName": item.StrategyName,
      "StartDate": item.ReturnStartDate,
      "EndDate": item.ReturnEndDate
  }
  });
  useEffect(() => {
    if(!showGridValue)
    {
    setFilteredAsset([]);
    setFilteredGroup([]);
    }
    else {
      if (selectedOption === "asset") {
        const filteredAssets = ProformaEntities.filter(item => item.NoReturns!=true);
        setFilteredAsset(filteredAssets);        
        setFilteredGroup([]);
      }
      else if (selectedOption === "group") {
        const filteredreturngroup = formattedUniverseItem.filter(item => item.NoReturns!=true);
        setFilteredGroup(filteredreturngroup);
        setFilteredAsset([]);
      };
    } 
  }, [ProformaEntities,universeItem]);
  const addAllocationButtonClick = () => {
    const gridApi = gridApiRef.current.api;
    const newSelectedRows = gridApi.getSelectedRows();
    handleAddSelectedRows(newSelectedRows);
    setShowDrawer(false);
    gridApi.deselectAll();
  };

  const handleRadioChange = (event) => {
    setSelectedRadioOption(event.target.value);
    setFilteredAsset([]);
    setFilteredGroup([]);
  };

  const entityDataOnchange = (event) => {
    setselectedEntity(event.target.value);
  };

  const searchContains = (event) => {
    setContains(event.target.checked);
  };

  const searchEntity = (e) => {
    if (selectedEntity !== undefined)
      dispatch(getProformaEntitiesAction(selectedEntity, isContains, 0));
      setShowGridValue(true);
  };
  const loadOnEnter = (event) => {
    if (event.key === 'Enter') {
        searchEntity();
    }
};
  const columnDefs = [
    {
      checkboxSelection: true,
      maxWidth: 40,
      filter: false,
    },
    {
      field: "EntityName",
        headerName: "Entity Name",
    },
    {
      field: "StrategyName",
        headerName: "Strategy Name",
      maxWidth: 200
      },
      {
          field: "EntityTypeName",
          headerName: "Entity Type",
          maxWidth: 120
      },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    flex: 1,
    resizable:true
  };

  const getUniverseList = (e) => {
    console.log(e,'event')
    if(e.syntheticEvent.type==="change" )
    {
      if (e.value) {
        sbaAxios({ url: `${getEntities}/${e.value},${isContains},${5}`, method: 'get' }).then(response => {
          setUniverseList(response);
        }).catch(error => {
          console.log(error, 'error fetching universe List');
        });
      }
    }
    if(e.syntheticEvent.type==="click")
    {
      const selectedDataItem = universeList.find(item => item.EntityName === e.target.value);
      dispatch(getUniverseMembersAction(selectedDataItem.EntityId , null));
      setShowGridValue(true);

    }
  };
  return (
    <>
      <div id="AssetandGroupdiv">
        <div className="col-lg-12">
          <div className="col-lg-12 mb-4">
            <div className="mb-4">
              <span className="fw-medium">Select Category</span>
              <div className="mb-4">
                <div className="d-flex align-items-center gap-5">
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="table-options"
                      id="asset"
                      value="asset"
                      checked={selectedOption === "asset"}
                      onChange={handleRadioChange}
                    />
                    <label htmlFor="asset" className="form-check-label">
                      Asset
                    </label>
                  </div>
                  <div className="form-check ms-3">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="table-options"
                      id="group"
                      value="group"
                      checked={selectedOption === "group"}
                      onChange={handleRadioChange}
                    />
                    <label htmlFor="group" className="form-check-label">
                      Group
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-4">
                    <span className="fw-medium">Search</span>
                    {selectedOption === "asset" && <div className="mb-4">
                      <div className="w-100">
                        <input
                          type="text"
                          className="form-control"
                          value={selectedEntity}
                          onChange={entityDataOnchange}
                          onKeyUp={loadOnEnter}
                        />
                      </div>
                    </div>}
                    {selectedOption === "group" && 
                      <div className="w-100">
                        <SBAAutoComplete 
                        data={universeList} 
                        onChange={(e) => { getUniverseList(e) }} 
                        textField="EntityName" 
                        popupSettings={{ style: 'z-index:1051', className: 'modalDD' }} 
                        suggest={false}
                        valueField={"EntityId"}
                        clearButton={false}
                         />
                    </div>}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-4">
                    <label></label>
                    <label className="d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        className=""
                        checked={isContains}
                        onChange={searchContains}
                      />
                      <span className="fw-medium">is Contains</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {selectedOption === "asset" && <>
              <div className="col-md-12">
                <button
                  type="button"
                  className="s-sm-btn mx-1"
                  onClick={()=>{searchEntity()}}
                >
                  Search
                </button>
              </div></>}
          </div>
          <div className="mb-4">
            <hr />
          </div>
          <div className="col-lg-12 row m-0 gap-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="col-lg-3">
                <div className="d-flex align-items-center">
                  <h2 className="fw-bold fs-6 m-0">Lists of Results</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: "350px" }}
            >
              <AgGridReact
                columnDefs={columnDefs}
                rowData={ selectedOption !== "group"?filteredAsset:filteredGroup}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationPageSize={20}
                rowSelection="multiple"
                rowMultiSelectWithClick
                ref={gridApiRef}
              ></AgGridReact>
            </div>
          </div>
          <br></br>
          <div className="col-lg-12"></div>
          <div className="col-lg-12 d-flex gap-1 align-items-center">
            <div>
              <button
                type="button"
                className="p-sm-btn mx-1"
                onClick={addAllocationButtonClick}
              >
                Add to Allocation
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
